// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cr-2";
export var aiChatCartContainerExit = "_cr-4";
export var aiChatContainerLarge = "_cr-0";
export var aiChatContainerSmall = "_cr-1";
export var aiChatIcon = "_cr-6";
export var slideInFromRight = "_cr-3";
export var slideOutToRight = "_cr-5";